import script from "./MDTextPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./MDTextPreview.vue?vue&type=script&setup=true&lang=js"

import "./MDTextPreview.vue?vue&type=style&index=0&id=f9f201ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9f201ae"]])

export default __exports__